<script lang="ts">
</script>

<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.4912472540314!2d126.77389791558706!3d37.496330335902805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b7d37c9943aef%3A0xf8d30f867082e6de!2z64KY656Y7Yq4656c65Oc!5e0!3m2!1sko!2skr!4v1650616122459!5m2!1sko!2skr"
  height="300"
  style="border:0;"
  allowfullscreen=""
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
/>

<!--
    2. 설치 스크립트
    * 지도 퍼가기 서비스를 2개 이상 넣을 경우, 설치 스크립트는 하나만 삽입합니다.
-->
<style lang="scss">
  iframe {
    width: 100%;
  }
  #player {
    width: 100%;
    height: 100%;
  }
  #movie-bg {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 1;

    #movie-shield {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100vh;
      z-index: 2;
      overflow: hidden;
    }

    .slot {
      width: 100%;
      height: 100%;
      z-index: 4;
    }
  }
</style>
